import { Component, Input, SimpleChanges } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { BehaviorSubject, combineLatest, map, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { ProductService } from 'src/app/services/product.service';
import { Drink, DrinkOrder } from 'src/interfaces/drink.model';
import { Units } from 'src/interfaces/enums.model';
import { Locale } from 'src/interfaces/locale.model';
import { Modificators } from 'src/interfaces/modificators.model';
import { NO_PHOTO } from 'src/app/utils/no-photo';

@Component({
    selector: 'app-order-drink-card',
    templateUrl: './menu-order-drink-card.component.html',
    styleUrls: ['./menu-order-drink-card.component.css'],
    standalone: false
})
export class MenuOrderDrinkCardComponent {
  constructor(
    private dataService: DataService,
    private imageCache: ImageCacheService,
    private productService: ProductService
  ) {
    this.locale = this.dataService.locale;
    this.guestId = this.dataService.guestId;
  }

  drink: Drink | null = null;
  modificators: Modificators | null = null;
  locale: Locale | null = null;
  guestId: string;
  unit: Units = Units.unit;

  // Изображение заглушка
  imageSrc: string = NO_PHOTO.drink;

  @Input() drinkOrder: DrinkOrder | null = null;
  @Input() isLast: boolean = false;

  private destroy$ = new Subject<void>();
  private drinkSubject = new BehaviorSubject<DrinkOrder | undefined>(undefined);

  ngOnInit(): void {
    if (this.drinkOrder) {
      this.drinkSubject.next(this.drinkOrder);
    }
    combineLatest([this.drinkSubject, this.productService.drinks$]).pipe(
      takeUntil(this.destroy$),
      map(([drink, drinks]) => drink ? drinks.filter(f => f.id === drink.id) : []),
    ).subscribe(filtered => {
      if (filtered.length && this.drinkOrder) {
        this.drink = cloneDeep(filtered[0]);
        console.log('OrderDrinkCard | subscribe() | drink: ', this.drink.title);
        // Image
        if (this.drink.image?.trim()) {
          this.imageCache.getImage(this.drink.image, NO_PHOTO.drink).then(src => {
            this.imageSrc = src;
          });
        }

        // Count
        if (this.drinkOrder.count) {
          this.drink.count = this.drinkOrder.count;
        }

        // Price
        if (this.drinkOrder.price) {
          this.drink.price = this.drinkOrder.price;
        }

        // Choise
        if (this.drinkOrder.choise) {
          this.drink.choise = this.drinkOrder.choise;
        }

        // Восстановление модификаторов
        if (this.drinkOrder?.modificators && typeof this.drinkOrder.modificators === 'object') {
          const orderModificators = this.drinkOrder.modificators || [];

          // Восстанавливаем модификаторы
          const modificators = typeof this.drink.modificators === 'object' ? this.drink.modificators : undefined;
          if (modificators) {
            this.modificators = cloneDeep(this.drink.modificators) as Modificators;
            this.modificators.items.forEach((modificator: any) => {
              const orderModificator = orderModificators.find((item: any) => item.id === modificator.id);
              if (orderModificator) {
                modificator.count = orderModificator.count;
              }
            });
            this.modificators.items = this.modificators.items.filter((modificator: any) => modificator.count > 0);
          }
        }
      }
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['drinkOrder'] && changes['drinkOrder'].currentValue !== changes['drinkOrder'].previousValue) {
      this.drinkSubject.next(changes['drinkOrder'].currentValue);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get localSize(): string {
    return this.drink?.size ? this.drink?.size.toLocaleString('ru-RU', { useGrouping: true }) : '';
  }
}
